import CCOM from './CCOM';

class FrontPanel {
    constructor() {
        //Inicializando uso de front panel
        if(CCOM && CCOM.System)
            CCOM.System.frontPanelControl(true);
        console.log('EDM: FRONT PANEL ACTIVADO');
    }

    clearDisplay() {
        if(CCOM && CCOM.System)
            CCOM.System.setFrontPanelString("");
    }

    setFrontPanel(string) {
        if(CCOM && CCOM.System)
          CCOM.System.setFrontPanelString(string);
    }

    showTime() {
        const that = this;
        const clock = new Date();
        const hours = clock.getHours();
        let minutes = clock.getMinutes();

        minutes = this.addZero(minutes);

        if (CCOM && CCOM.System) CCOM.System.setFrontPanelString(`${hours}:${minutes}`);
        this.clockId = setTimeout(function() {
            that.showTime();
        }, 60000);
    }

    /* Método para agregar un 0
    si los minutos son menores a 10 */
    addZero(i) {
        if (i < 10) {
            i = `0${i}`;
        }
        return i;
    }

    launchVirtualKey() {
        const e = new Event('keydown');
        e.key = 'play';
        e.keyCode = 179;
        e.which = e.keyCode;
        document.dispatchEvent(e);
    }

    standByBox(isLive) {
        if (CCOM && CCOM.Pwrmgr) CCOM.Pwrmgr.userModeSet(CCOM.Pwrmgr.STANDBY_ON);
        if (CCOM && CCOM.System) CCOM.System.setFrontPanelIntensityLevel(1);
        this.showTime();

        if (isLive) this.launchVirtualKey();
    }

    turnOnBox(isLive) {
        CCOM.Pwrmgr.userModeSet(CCOM.Pwrmgr.STANDBY_OFF);
        CCOM.System.setFrontPanelString('');
        CCOM.System.setFrontPanelIntensityLevel(8);

        if (this.clockId) clearInterval(this.clockId);

        if (isLive) this.launchVirtualKey();
    }
}

export default new FrontPanel();



// WEBPACK FOOTER //
// ./src/devices/nagra/FrontPanel.js